import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Header from '../components/Header';
import './BookingConfirmationPage.css';

export default function BookingConfirmationPage() {
  const { state } = useLocation();
  const booking = state?.booking;

  if (!booking) {
    return (
      <div>
        <Header />
        <div className="container" style={{ padding: '60px 16px', textAlign: 'center' }}>
          <h2>Страница не найдена</h2>
          <Link to="/" className="btn btn-primary" style={{ marginTop: 20 }}>На главную</Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="container confirm-container">
        <div className="confirm-card card">
          <div className="confirm-icon">🎉</div>
          <h1 className="confirm-title">Заявка принята!</h1>
          <p className="confirm-subtitle">
            Мы получили вашу заявку и свяжемся с вами в течение 30 минут для подтверждения.
          </p>

          <div className="confirm-ref">
            <span className="ref-label">Номер вашей заявки</span>
            <span className="ref-value">{booking.booking_ref}</span>
            <span className="ref-hint">Сохраните этот номер — по нему можно проверить статус брони</span>
          </div>

          <div className="confirm-details">
            <div className="confirm-row">
              <span>Квартира</span>
              <span>{booking.apartment_name}</span>
            </div>
            <div className="confirm-row">
              <span>Заезд — Выезд</span>
              <span>{booking.check_in} → {booking.check_out}</span>
            </div>
            <div className="confirm-row">
              <span>Ночей</span>
              <span>{booking.nights}</span>
            </div>
            <div className="confirm-row confirm-row-total">
              <span>Итого (от)</span>
              <span>{new Intl.NumberFormat('ru-RU').format(booking.total_price_rub)} ₽</span>
            </div>
          </div>

          <div className="confirm-next">
            <h3>Что дальше?</h3>
            <ol className="confirm-steps">
              <li>Мы позвоним на <strong>{booking.guest_phone || 'ваш номер'}</strong> для подтверждения</li>
              <li>После подтверждения вышлем реквизиты для оплаты СБП</li>
              <li>Вы оплачиваете — мы присылаем адрес и инструкции по заселению</li>
            </ol>
          </div>

          <div className="confirm-actions">
            <Link to={`/booking/${booking.booking_ref}`} className="btn btn-secondary">
              Проверить статус брони
            </Link>
            <Link to="/" className="btn btn-primary">
              Вернуться на главную
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
